import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../../shared/services/auth/login/login.service';

declare var jQuery: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {
  public distance: number;
  public userData: any;

  constructor(
    private elRef: ElementRef,
    private router: Router,
    private loginService: LoginService
  ) { }

  toggleMenu() {
    if (window.outerWidth < 768) {
      if (jQuery('#container').hasClass('open')) {
        this.resetMenu();
      } else {
        this.openMenu();
      }
    } else {
      jQuery('#container').toggleClass('mainnav-sm');
      jQuery('.objeto-logo-paguela').removeClass('active');
      jQuery('.pague-la-texto').toggleClass('active');
    }
  }

  ngOnInit() {
    this.router.events.subscribe(
      () => {
        if (window.outerWidth < 768) {
          this.resetMenu();
        }
      }
    );

    jQuery('.pague-la-texto').on(
      'transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd',
      function () {
        if (jQuery('.pague-la-texto').hasClass('active')) {
          jQuery('.objeto-logo-paguela').addClass('active');
        }
      });
  }

  resetMenu() {
    jQuery('#navbar, #content-container, #mainnav-container').css({ transition: '.25s ease' });
    jQuery('#navbar, #content-container').css({ transform: 'translate3d(0, 0, 0)' });
    jQuery('#mainnav-container').css({ transform: 'translate3d(0, 0, 0)' });
    jQuery('#container').removeClass('open');
    jQuery('.mainnav-toggle').removeClass('is-active');
  }

  openMenu() {
    jQuery('#navbar, #content-container, #mainnav-container').css({ transition: '.25s ease' });
    jQuery('#navbar, #content-container').css({ transform: 'translate3d(220px, 0, 0)' });
    jQuery('#mainnav-container').css({ transform: 'translate3d(220px, 0, 0)' });
    jQuery('#container').addClass('open');
    jQuery('.mainnav-toggle').addClass('is-active');
  }

  logOut() {
    this.loginService.logOut();
  }

  ngAfterViewInit() {
    // if (window.outerWidth < 768) {

    //   jQuery('#navbar, #content-container, #mainnav-container').on(
    //     'transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd',
    //     function () {
    //       jQuery('#navbar, #content-container, #mainnav-container').css({ transition: 'none' });
    //     }).children().on(
    //     'transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd',
    //     function () {
    //       return false;
    //     });

    //   jQuery('body').on('drag', e => {

    //     // let the default vertical scrolling happen
    //     if ('vertical' === e.orientation) {
    //       return;
    //     }

    //     this.distance = jQuery('#container').hasClass('open') ? 220 + e.dx : e.dx;

    //     if (this.distance >= 0 && this.distance <= 220) {
    //       jQuery('#navbar, #content-container, #mainnav-container').css({ transition: 'none' });
    //       jQuery('#navbar, #content-container').css({ transform: 'translate3d(' + this.distance + 'px, 0, 0)' });
    //       jQuery('#mainnav-container').css({ transform: 'translate3d(' + this.distance + 'px, 0, 0)' });
    //     }

    //     if (e.end) {
    //       if (Math.abs(e.dx) >= 75) {
    //         if (e.dx < 0) {
    //           this.resetMenu();
    //         } else {
    //           this.openMenu();
    //         }
    //       } else {
    //         if (e.dx < 0) {
    //           this.openMenu();
    //         } else {
    //           this.resetMenu();
    //         }
    //       }

    //     }
    //     // prevent default horizontal scrolling
    //     e.preventDefault();
    //   });
    // }
  }
}
